/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../../redux/hooks'
import {fetchCheckStock} from '../../../../services/fetcher'
import {
  resetFilterMasterJBPType,
} from '../../../../redux/slices/filterSlices'
import {useRowTable} from '../../../../hooks/useRowTable'
import * as TableUI from '../../../../components/Table/Table'
import {StyledCard} from '../../../../components/StyledCard'
import i18next from 'i18next'
import {Filter} from './Filter'
import { ModalSO } from './ModalSO'
import { RowFilter } from './table/RowFilter'
import { Pagination } from 'react-bootstrap'

const Table: React.FC = () => {
  const dispatch = useAppDispatch()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 8,
    onReloadTable: () => handleResetTable(),
  })

  const {t} = useTranslation()

  const [stocks, setStocks] = useState([])
  const [filtered, setFiltered] = useState([])
  const [paged, setPaged] = useState([])

  const [currPage, setCurrPage] = useState(1)
  const [pages, setPages] = useState<any[]>([])
  const [totalPages, setTotalPages] = useState(1)

  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const [showSO, setShowSO] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})

  const limit = 10

  const onFetchDatas = (filter = {}) => {
    setLoading(true)
    setIsError(false)

    setCurrPage(1)
    setTotalPages(1)
    setPages([])

    fetchCheckStock({
      data: [filter]
    })
      .then((res: any) => {
        setStocks(res.data.data)
      })
      .catch((e: any) => {
        console.log(e)
        setIsError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleResetTable = () => {
    dispatch(resetFilterMasterJBPType())
  }

  const formatStock = (stock: number, ptype: string, _unit: string = '') => {
    let num = stock?.toLocaleString(i18next.language, {
      maximumFractionDigits: 4,
    })
    let unit = ptype == '8105' ? _unit : i18next.language == 'id' ? 'Ton' : 'MT'

    return num ? [num, unit].join(' ') : '-'
  }

  const showSOBreakdown = (data: Record<string, any>) => {
    setShowSO(true)
    setSelectedItem(data)
  }

  useEffect(() => {
    setFiltered(stocks)
  }, [stocks])
  useEffect(() => {
      applyPagination()
  }, [filtered, currPage])

  const isMatch = (data: any, fil: any) => {
    if(typeof data == 'number'){
        return (data.toString().toLowerCase()).includes(fil.toLowerCase())
    }else{
        return (data.toLowerCase()).includes(fil.toLowerCase())
    }
  }

  const applyFilter = (filter: Record<string, any>) => {
      setCurrPage(1)
      setPages([])
      setTotalPages(1)

      const filteredData = stocks.filter((item: any) => {
          let match = true;

          if(filter.material && (
              !(isMatch(parseInt(item?.material_number), filter.material))
              && !(isMatch(item?.material_desc, filter.material))
          )) {
              match = false;
          }
          if(filter.plant && (
              !(isMatch(item?.plant, filter.plant))
              && !(isMatch(item?.plant_desc, filter.plant))
          )) {
              match = false;
          }
          if(filter.sloc && (
              !(isMatch(item?.sloc, filter.sloc))
              && !(isMatch(item?.sloc_desc, filter.sloc))
          )) {
              match = false;
          }
          
          if(filter.uu && item?.stock_uu != filter.uu) {
              match = false;
          }

          if(filter.sap && item?.stock != filter.sap) {
              match = false;
          }

          if(filter.outstanding && item?.stock_used != filter.outstanding) {
              match = false;
          }
          if(filter.remaining && item?.stock_available != filter.remaining) {
              match = false;
          }

          return match
      })

      setFiltered(filteredData)
  }

  const applyPagination = () => {
    let count = filtered.length
    let _totalPages = (count != 0) ? Math.ceil(count / limit) : 1;

    setPaged([])

    var _pages = [];
    
    let startPage, endPage;
    const maxVisiblePages = 7;
    if (currPage <= Math.floor(maxVisiblePages / 2) + 1) {
        startPage = 1;
        endPage = maxVisiblePages;
    }
    else if (currPage + Math.floor(maxVisiblePages / 2) >= _totalPages) {
        startPage = _totalPages - maxVisiblePages + 1;
        endPage = _totalPages;
    }
    else {
        startPage = currPage - Math.floor(maxVisiblePages / 2);
        endPage = currPage + Math.floor(maxVisiblePages / 2);
    }

    if(_totalPages > 7){
        if(startPage > 1){
            _pages.push(0)
            _pages.push('-')
            _pages.push('...')
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        if(i > 0 && i <= _totalPages){
            _pages.push(i);
        }
    }

    if(_totalPages > 7){
        if(endPage < _totalPages-maxVisiblePages){
            _pages.push('...')
            _pages.push('+')
            _pages.push(-1)
        }
    }

    setPages(_pages)
    setTotalPages(_totalPages)

    const startIndex = (currPage - 1) * limit
    setPaged(filtered.slice(startIndex, startIndex + limit))
  }

  return (
    <StyledCard>
      <div className='card-body'>
        <Filter onFilter={onFetchDatas} loading={loading} />
        <hr />

        <div className='my-5'>
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <tr>
                  <th>{t('No')}</th>
                  <th>{t('sub-order-produk')}</th>
                  <th>{t('sub-order-gudang')}</th>
                  <th>{t('storage location')}</th>
                  <th>{t('uu-stock')}</th>
                  <th>{t('sap-stock')}</th>
                  <th>{t('outstanding-stock')}</th>
                  <th>{t('remaining-stock')}</th>
                </tr>
              </TableUI.THead>
              <TableUI.TBody>
                <RowFilter applyFilter={applyFilter}/>
                {loading ? (
                  <RowLoader />
                ) : isError ? (
                  <RowErrorFetch />
                ) : stocks?.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  paged?.map((item: any, _index: number) => (
                    <tr key={item?.code ?? _index}>
                      <td>{((currPage - 1) * limit) + _index + 1}</td>
                      <td>{[parseInt(item?.material_number), item?.material_desc].join(' - ')}</td>
                      <td>{[item?.plant, item?.plant_desc].join(' - ')}</td>
                      <td>{[item?.sloc, item?.sloc_desc].join(' - ')}</td>
                      <td>{formatStock(item.stock_uu, item?.product_type, item?.unit)}</td>
                      <td>{formatStock(item.stock, item?.product_type, item?.unit)}</td>
                      <td>
                        {
                          item.stock_used ?
                          <a
                            href='javascript:void(0)'
                            onClick={() => showSOBreakdown(item)}
                            className='cursor-pointer hover-underline'
                          >
                            {formatStock(item.stock_used, item?.product_type, item?.unit)}
                          </a> : '-'
                        }
                      </td>
                      <td>{formatStock(item.stock_available, item?.product_type, item?.unit)}</td>
                    </tr>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>

        </div>

        <Pagination>
            {
                pages.map((page) => {
                    if(page == '-'){
                        return <Pagination.Prev onClick={() => setCurrPage(currPage-1)}/>
                    }
                    if(page == 0){
                        return <Pagination.First onClick={() => setCurrPage(1)}/>
                    }
                    if(page == '+'){
                        return <Pagination.Next onClick={() => setCurrPage(currPage+1)}/>
                    }
                    if(page == -1){
                        return <Pagination.Last onClick={() => setCurrPage(totalPages)}/>
                    }
                    if(page == '...'){
                        return  <Pagination.Ellipsis disabled/>
                    }
                    return <Pagination.Item onClick={() => setCurrPage(page)} active={page == currPage} key={'page-' + page}>{page}</Pagination.Item>
                })
            }
        </Pagination>
      </div>

      <ModalSO isShow={showSO} setShow={(p: boolean) => setShowSO(p)} filter={selectedItem}/>
    </StyledCard>
  )
}

export {Table}
